module.exports = __webpack_public_path__ + "static/media/22934935.fa4ce669.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/22934935.mp4
// module id = 759
// module chunks = 0